/* src/app/ai-sourcing/custom-modal/custom-modal.component.scss */
.overlay-container {
  position: fixed;
  top: 60%;
  left: 60%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
.modal-box {
  background: #fff;
  padding: 24px;
  width: 420px;
  border-radius: 10px;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.15);
}
/*# sourceMappingURL=custom-modal.component-4JWT7GP3.css.map */
